{% block postfinancecheckout_order_action_completion %}
<sw-modal variant="small"
		  :title="$tc(`postfinancecheckout-order.modal.title.capture`)"
		  @modal-close="$emit('modal-close')">

	{% block postfinancecheckout_order_action_completion_amount %}
		<mt-checkbox
				:label="$tc('postfinancecheckout-order.captureAction.button.text')"
				v-model:checked="isCompletion">
        </mt-checkbox>
	{% endblock %}

	{% block postfinancecheckout_order_action_completion_confirm_button %}
	<template #modal-footer>
		<mt-button variant="primary"
				   @click="completion">
			{{ $tc('postfinancecheckout-order.refundAction.confirmButton.text') }}
		</mt-button>
	</template>
	{% endblock %}

	<mt-loader v-if="isLoading"></mt-loader>
</sw-modal>
{% endblock %}
